/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component, createRef } from 'react';
import { Button, FormControl, Overlay, Tooltip, Spinner } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import store from 'features/store';
import { MyAccountMenuList, removeSideBar, ToggleSideBar } from '../MyAccountMenuList';
import ToasterMessage from 'shared/toast/toast';
import { MyAccountService } from 'shared/services';
import Validators from 'shared/validators';

import './ChangePassword.scss';
import { logout } from 'shared/settings/auth';
/**

user password change

@Author karthik

@param

@return html code for change password

**/

export class ChangePassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            password: { value: '', showPassword: false, error: false },
            passwordStrength: { status: '', upper: false, numeric: false, count: false, special: false, lower: false },
            confirmPassword: { value: '', showPassword: false, error: '' },
            valid: false,
            windowWidth: window.innerWidth,
            loading: false,
            passwordTarget: false
        };

        this.toasterMessage = createRef();
        this.passwordForm = createRef();
    }

    componentDidMount() {
        store.dispatch({ type: 'SIDEBAR_MENU_LIST', payload: { menuList: MyAccountMenuList(), withSpan: false } });
        this.updateDimensions();
        window.addEventListener('resize', this.updateDimensions);
    }

    /* Detect window width */
    updateDimensions = () => {
        ToggleSideBar();
        this.setState({ ...this.state, windowWidth: window.innerWidth });
    };

    /* toggles when clicking password eye icon */
    useShowPassword = (name) => {
        this.setState(() => ({
            [name]: { ...this.state[name], showPassword: !this.state[name].showPassword }
        }));
    }

    /* check validation for input changes */
    handlePasswordInput = (name, passwordValue, target = null) => {
        passwordValue = Validators.checkPassword(passwordValue, this.state[name].value);
        this.setState({
            ...this.state,
            [name]: { ...this.state[name], value: passwordValue, error: passwordValue.length >= 8 ? false : true },
            passwordTarget: target ? target : this.state.passwordTarget
        }, () => {
            if (name === "password") {
                this.checkPasswordStrength(passwordValue);
            }
            else
                this.checkPassword(passwordValue);
        });
    }

    /* validation of password strength */
    checkPasswordStrength = (enteredPassword) => {
        const upperRegExp = new RegExp("^(?=.*[A-Z])");
        const lowerRegExp = new RegExp("^(?=.*[a-z])");
        const specialRegExp = new RegExp("^(?=.*[!@#$%^&*])");
        const numericRegExp = new RegExp("^(?=.*[0-9])");
        const lengthRegExp = new RegExp("^(?=.{8,15})");
        var strength = 0;
        let lowerCheck = false;
        let specialCheck = false;
        let upperCheck = false;
        let numericCheck = false;
        let countCheck = false;

        /* check for uppercase character in password */
        if (upperRegExp.test(enteredPassword)) {
            strength += 1;
            upperCheck = true;
        }
        /* check for lowercase character in password */
        if (lowerRegExp.test(enteredPassword)) {
            strength += 1;
            lowerCheck = true;
        }
        /* check for special character in password */
        if (specialRegExp.test(enteredPassword)) {
            strength += 1;
            specialCheck = true;
        }
        /* check for number in password */
        if (numericRegExp.test(enteredPassword)) {
            strength += 1;
            numericCheck = true;
        }
        /* check for Minimum 8- Maximum 15 characters */
        if (lengthRegExp.test(enteredPassword) && enteredPassword.length < 16) {
            strength += 1;
            countCheck = true;
        }


        /* password strength Weak */
        if (strength < 4) {
            this.setState({
                ...this.state,
                password: { ...this.state.password, value: enteredPassword, error: true },
                passwordStrength: { status: 'Weak', upper: upperCheck, numeric: numericCheck, count: countCheck, lower: lowerCheck, special: specialCheck }
            }, () => {
                if (this.state.confirmPassword.value) {
                    this.checkPassword(this.state.confirmPassword.value);
                }
            });
        }
        /* password strength Good */
        else if (strength === 4) {
            this.setState({
                ...this.state,
                password: { ...this.state.password, value: enteredPassword, error: true },
                passwordStrength: { status: 'Good', upper: upperCheck, numeric: numericCheck, count: countCheck, lower: lowerCheck, special: specialCheck }
            }, () => {
                if (this.state.confirmPassword.value) {
                    this.checkPassword(this.state.confirmPassword.value);
                }
            });
        }

        /* password strength Strong */
        else if (strength === 5) {
            this.setState({
                ...this.state,
                password: { ...this.state.password, value: enteredPassword, error: false },
                passwordStrength: { status: 'Strong', upper: upperCheck, numeric: numericCheck, count: countCheck, lower: lowerCheck, special: specialCheck }
            }, () => {
                if (this.state.confirmPassword.value) {
                    this.checkPassword(this.state.confirmPassword.value);
                }
            }
            );
        }
    }

    /* validation of confirm password */
    checkPassword = (confirmPasswordValue) => {
        let errorString = "Password does not match";
        /* password match check */
        if (this.state.password.value === confirmPasswordValue) {
            this.setState({
                ...this.state,
                confirmPassword: { ...this.state.confirmPassword, value: confirmPasswordValue, error: '' },
                valid: true
            });

        }
        else {
            this.setState({
                ...this.state,
                confirmPassword: { ...this.state.confirmPassword, value: confirmPasswordValue, error: errorString },
                valid: false
            });
        }
    }

    /* hide tooltip on input blur */
    passwordBlur = () => {
        if (this.state.password.value.length < 1) {
            this.setState({
                ...this.state,
                password: { ...this.state.password, error: false }
            });
        }
    }

    /* called when save button clicked and change the password*/
    submitPassword = () => {
        this.setState({ loading: true });
        let password = { password: btoa(this.state.confirmPassword.value) };
        MyAccountService.changePassword({ data: password })
            .then(response => {
                if (response.status === 200) {
                    this.setState({ loading: false });
                    // TODO: success message handle
                    this.setState({
                        confirmPassword: {
                            ...this.state.confirmPassword,
                            value: ''
                        },
                        password: {
                            ...this.state.password,
                            value: ''
                        },
                        valid: false
                    });
                    this.toasterMessage.current.showMessage({ type: 'success', message: response.data.message });
                }
            })
            .catch(error => {
                // TODO: Error message handle
                if (error?.status === 401) {
                    store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                    logout(this.props.history, false);
                    removeSideBar();
                } else {
                    this.toasterMessage.current.showMessage({ type: 'danger', message: error.message });
                    this.setState({ loading: false });
                }
            });
    }

    componentWillUnmount() {
        store.dispatch({ type: 'SET_SIDEBAR', payload: false });
        window.removeEventListener('resize', this.updateDimensions);
    }

    render() {
        const { password, passwordStrength, confirmPassword, valid } = this.state
        let status = passwordStrength.status;
        /* css class based on password strength */
        let progressBarClass = 'progress-bar';
        let progressStrengthClass = ''
        if (status === 'Weak') {
            progressBarClass = "progress-bar progress-bar-danger progress-bar-weak-width";
            progressStrengthClass = "text-danger";
        }
        else if (status === 'Good') {
            progressBarClass = "progress-bar progress-bar-success progress-bar-good-width";
            progressStrengthClass = "text-success good";
        }
        else if (status === 'Strong') {
            progressBarClass = "progress-bar progress-bar-success progress-bar-strong-width";
            progressStrengthClass = "text-success strong";
        }

        return (
            <div className="d-flex flex-column top-border change-password-main">
                <div className="change-password">
                    {
                        ((passwordStrength.upper || passwordStrength.numeric || passwordStrength.count || passwordStrength.lower || passwordStrength.special) && this.state.windowWidth < 768 && password.error === true) ?
                            <div className="mobile-view-password-strength">
                                <ul className="list-unstyled">
                                    <li className=""><span className={passwordStrength.lower ? "lower-case text-success" : ""}><i className={passwordStrength.lower ? "fa fa-check" : "fa fa-times"} aria-hidden="true"></i></span>&nbsp;Atleast 1 Lowercase (a-z)</li>
                                    <li className=""><span className={passwordStrength.upper ? "upper-case text-success" : ""}><i className={passwordStrength.upper ? "fa fa-check" : "fa fa-times"} aria-hidden="true"></i></span>&nbsp;Atleast 1 Uppercase (A-Z)</li>
                                    <li className=""><span className={passwordStrength.numeric ? "one-number text-success" : ""}><i className={passwordStrength.numeric ? "fa fa-check" : "fa fa-times"} aria-hidden="true"></i></span> &nbsp;Atleast 1 Number (0-9)</li>
                                    <li className=""><span className={passwordStrength.count ? "eight-character text-success" : ""}><i className={passwordStrength.count ? "fa fa-check" : "fa fa-times"} aria-hidden="true"></i></span>&nbsp;Between 8 to 15 Characters</li>
                                    <li className=""><span className={passwordStrength.special ? "special-char text-success" : ""}><i className={passwordStrength.special ? "fa fa-check" : "fa fa-times"} aria-hidden="true"></i></span>&nbsp;Atleast 1 Symbol Character</li>
                                    <li className="">Allowed Symbol Characters (!, @, #, $, %, ^, &, *)</li>
                                </ul>
                            </div> : null
                    }
                    <div className="container-width">
                        <Form className="change-password-card py-3">
                            <div className="pad-set mt-2">
                                <div className="float-control" ref={this.passwordForm}>
                                    {
                                        password.showPassword ?
                                            <i className="password-icon fas fa-eye fa-flip-horizontal" onClick={() => this.useShowPassword('password')} /> :
                                            <i className="password-icon fas fa-eye-slash fa-flip-horizontal" onClick={() => this.useShowPassword('password')} />
                                    }
                                    <Form.Control type={password.showPassword ? 'text' : 'password'} id="password" name="password" placeholder=" " onBlur={this.passwordBlur} onChange={(event) => this.handlePasswordInput(event.target.name, event.target.value, event.target)} value={this.state.password.value} />
                                    <label htmlFor="password" >New Password</label>
                                </div>
                                <Overlay
                                    transition={false}
                                    container={this.passwordForm.current}
                                    target={this.state.passwordTarget}
                                    id="overlay"
                                    placement={this.state.windowWidth > 760 ? "right" : "top"}
                                    show={(passwordStrength.upper && passwordStrength.numeric && passwordStrength.count && passwordStrength.lower && passwordStrength.special) || (password.error === false) || (this.state.windowWidth < 768) ? false : true}
                                >
                                    <Tooltip className="overlay-tooltip">
                                        <div>
                                            <p style={{ marginBottom: "4px" }}>Password Strength:&nbsp;&nbsp;<span className={progressStrengthClass}>{passwordStrength.status}</span></p>
                                            <div className="progress">
                                                <div id="password-strength" className={progressBarClass} role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100">
                                                </div>
                                            </div>
                                            <ul className="list-unstyled">
                                                <li className=""><span className={passwordStrength.lower ? "lower-case text-success" : ""}><i className={passwordStrength.lower ? "fa fa-check" : "fa fa-times"} aria-hidden="true"></i></span>&nbsp;Atleast 1 Lowercase (a-z)</li>
                                                <li className=""><span className={passwordStrength.upper ? "upper-case text-success" : ""}><i className={passwordStrength.upper ? "fa fa-check" : "fa fa-times"} aria-hidden="true"></i></span>&nbsp;Atleast 1 Uppercase (A-Z)</li>
                                                <li className=""><span className={passwordStrength.numeric ? "one-number text-success" : ""}><i className={passwordStrength.numeric ? "fa fa-check" : "fa fa-times"} aria-hidden="true"></i></span> &nbsp;Atleast 1 Number (0-9)</li>
                                                <li className=""><span className={passwordStrength.count ? "eight-character text-success" : ""}><i className={passwordStrength.count ? "fa fa-check" : "fa fa-times"} aria-hidden="true"></i></span>&nbsp;Between 8 to 15 Characters</li>
                                                <li className=""><span className={passwordStrength.special ? "special-char text-success" : ""}><i className={passwordStrength.special ? "fa fa-check" : "fa fa-times"} aria-hidden="true"></i></span>&nbsp;Atleast 1 Symbol Character</li>
                                                <li className="">Allowed Symbol Characters (!, @, #, $, %, ^, &, *)</li>
                                            </ul>
                                        </div>
                                    </Tooltip>
                                </Overlay>
                            </div>
                            <div className="pad-set">
                                <div className="float-control">
                                    {
                                        confirmPassword.showPassword ?
                                            <i className="password-icon fas fa-eye fa-flip-horizontal" onClick={() => this.useShowPassword('confirmPassword')} /> :
                                            <i className="password-icon fas fa-eye-slash fa-flip-horizontal" onClick={() => this.useShowPassword('confirmPassword')} />
                                    }
                                    <FormControl type={confirmPassword.showPassword ? 'text' : 'password'} id="confirmPassword" name="confirmPassword" placeholder=" " onChange={(event) => this.handlePasswordInput(event.target.name, event.target.value)} value={this.state.confirmPassword.value} />
                                    <label htmlFor="confirmPassword">Retype Password</label>
                                    <div className="text" style={{ margin: "0px 0px", top: "auto", right: "auto", textAlign: "start" }}>
                                        {
                                            !valid && confirmPassword.error.length > 1 ?
                                                <small className="error">{confirmPassword.error}</small> : null
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-center">
                                <ToasterMessage className="alert-handle" ref={this.toasterMessage}></ToasterMessage>
                            </div>
                            <div className="mb-3 mt-2 d-flex align-items-center justify-content-center">
                                <Button type="submit" variant="" className='save-btn' style={{ width: '100px', cursor: valid ? '' : 'not-allowed' }}
                                    disabled={valid && this.state.passwordStrength.status === 'Strong' && !this.state.loading ? false : true}
                                    onClick={this.submitPassword}>
                                    Save {this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"></Spinner> : null}
                                </Button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}